var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 2.25H2.25V15.75H15.75V2.25Z",
    fill: "#99F6E4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.875 18H1.125C0.504 18 0 17.496 0 16.875V1.125C0 0.504 0.504 0 1.125 0H11.25C11.871 0 12.375 0.504 12.375 1.125C12.375 1.746 11.871 2.25 11.25 2.25H2.25V15.75H15.75V9C15.75 8.379 16.254 7.875 16.875 7.875C17.496 7.875 18 8.379 18 9V16.875C18 17.496 17.496 18 16.875 18Z",
    fill: "#455A64"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99988 11.2496C8.71188 11.2496 8.42388 11.1394 8.20338 10.9211L5.50338 8.2211C5.06463 7.78235 5.06463 7.0691 5.50338 6.63035C5.94213 6.1916 6.65538 6.1916 7.09413 6.63035L8.99988 8.53385L16.2584 1.27535C16.6971 0.836602 17.4104 0.836602 17.8491 1.27535C18.2879 1.7141 18.2879 2.42735 17.8491 2.8661L9.79638 10.9211C9.57588 11.1394 9.28788 11.2496 8.99988 11.2496Z",
    fill: "#455A64"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.5e0c7f48be22c6cee673fbf86a2bcd03.svg";
export { ForwardRef as ReactComponent };